export default __webpack_public_path__ + "static/media/HeroCompleteSigned.e5b2a278.png";